import { FormControl, InputLabel, NativeSelect, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { Icon24UtilityChevron } from '@care/react-icons';
import { TextField, FilterButton } from '@care/react-component-lib';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { MILES } from '@/constants';
import { DistanceUnit } from '@/__generated__/globalTypes';
import { saveFilters } from '../../../utils/filtersStorage';

interface Props {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
}

const Distance = (props: Props) => {
  const [distance, setDistance] = useState({
    zipCode: '',
    milesFromZipCode: 5,
  });
  const { handleClick, isClear, onChange } = props;

  const iconComponent = () => (
    <Icon24UtilityChevron component="select" height="20px" width="20px" />
  );
  const options =
    MILES &&
    MILES.map((mile) => (
      <option key={mile.value} value={mile.value}>
        {mile.label}
      </option>
    ));

  /*
   * handle apply
   */
  const handleApply = () => {
    saveFilters(
      {
        radius: { unit: DistanceUnit.MILES, value: distance.milesFromZipCode },
        zipcode: distance.zipCode,
      },
      onChange
    );

    const amplitudeData = {
      zipCode: distance.zipCode,
      milesFromZipCode: distance.milesFromZipCode,
    };

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, amplitudeData);
  };

  const handleMilesChange = (e: { target: { value: string } }) => {
    setDistance({ ...distance, milesFromZipCode: parseInt(e.target.value, 10) });
  };

  useEffect(() => {
    if (isClear) {
      setDistance({
        zipCode: '',
        milesFromZipCode: 5,
      });
    }
  }, [isClear]);

  return (
    <FilterButton
      field="Distance"
      label="Distance"
      selected={Boolean(distance.zipCode && distance.milesFromZipCode)}
      onApply={handleApply}
      onClick={handleClick}>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={6}>
          <FormControl variant="standard" component="fieldset" fullWidth>
            <TextField
              id="zip"
              required
              InputLabelProps={{ shrink: false }}
              name="zip"
              label="Zip Code"
              error={distance.zipCode.length < 5}
              value={distance.zipCode}
              onChange={(e) => setDistance({ ...distance, zipCode: e.target.value })}
              sx={{ minWidth: 0 }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="standard" component="fieldset" fullWidth>
            <InputLabel htmlFor="field-native-select">Within</InputLabel>
            <NativeSelect
              onChange={handleMilesChange}
              inputProps={{
                name: 'option',
                id: 'field-native-select',
              }}
              value={distance.milesFromZipCode}
              IconComponent={iconComponent}>
              {options}
            </NativeSelect>
          </FormControl>
        </Grid>
      </Grid>
    </FilterButton>
  );
};

export default Distance;
